import React from "react";
import Navbar from "../components/navbar";
import Footer from "../homeComponents/footer";
// import Footer from '../homeComponents/footer'
import { Helmet } from 'react-helmet';
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const Contacts = () => {

  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user = useSelector((state) => state.auth.user); // Get the entire user object

  const location = useLocation(); // Get current location
  const queryParams = new URLSearchParams(location.search); // Extract query parameters
  const type = queryParams.get("type") || "this service"; // Default to 'this service'

  // Function to handle WhatsApp message
  const handleWhatsApp = () => {
    const phoneNumber = "+919611560076";
    const message = encodeURIComponent(
      `Hi, I would like to enquire more about ${type}.`
    );
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  };

  return (
    <section className="w-full min-h-screen bg-banner font-clash">
      <Navbar />
      <Helmet>
              <title>Contact</title>
              <meta
                name="keywords"
                content="Pdi, Bengaluru, Bangalore, Kardo, Inspection, Ze, Pre delivery, Services, Car, Cars, Vaidya, BHP, Team, CID, Expert, In, Best, 24, BOSS, Dail, Just, New car, Checklist, Detailed, Report, Inspect, Reliable, Blog, Used car inspection, Buying a new car"
              />
              <meta
                name="description"
                content="Explore our reliable pre-delivery inspection services for new and used cars. Detailed reports, expert insights, and the best service in Bangalore and beyond."
              />
            </Helmet>      
      <div className="flex flex-col items-center justify-center min-h-screen w-full">
        <div className="flex items-start justify-start">
          <h1 className="text-4xl text-left font-semibold text-[#FFFF]">
            Hey, {user ? user.firstname : "User"}
          </h1>
        </div>
        <div className="flex items-center justify-center text-center mt-10 mx-2 max-w-[800px]">
          <h4 className="text-3xl font-semibold text-[#F0FFC5]">
            Contact and let us choose the best executives for your requirements
          </h4>
        </div>
        <div className="flex lg:flex-row flex-col items-center justify-center space-x-4 w-full mt-10">
        <a
        href="tel:+919611560076"
        className="text-[#F0FFC5] flex flex-row text-md items-center font-semibold py-4 px-12 mt-5 bg-[#060C0A] rounded-full shadow-inner-custom 
             transition-all duration-300 ease-in-out transform hover:scale-105 hover:bg-gradient-to-b hover:from-[#060C0A] hover:to-[#4c5b20] active:scale-95 active:translate-y-1">
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="mr-2"
  >
    <path
      d="M24.7559 18.6406L23.6309 23.375C23.4902 24.0781 22.9277 24.5469 22.2246 24.5469C10.4121 24.5 0.802734 14.8906 0.802734 3.07813C0.802734 2.375 1.22461 1.8125 1.92773 1.67188L6.66211 0.546877C7.31836 0.406252 8.02148 0.781252 8.30273 1.39063L10.5059 6.5C10.7402 7.10938 10.5996 7.8125 10.084 8.1875L7.55273 10.25C9.14648 13.4844 11.7715 16.1094 15.0527 17.7031L17.1152 15.1719C17.4902 14.7031 18.1934 14.5156 18.8027 14.75L23.9121 16.9531C24.5215 17.2813 24.8965 17.9844 24.7559 18.6406Z"
      fill="#F0FFC5"
    />
  </svg>
  Book a Call
</a>



          <button 
          onClick={handleWhatsApp}
          className="text-[#F0FFC5] lg:ml-5 text-md font-semibold py-3 px-14 mt-5 bg-transparent border-2  border-[#ADD143] rounded-full
                   transition-all duration-300 ease-in-out transform hover:scale-105 hover:bg-[#71892986] hover:border-[#9BC133] active:scale-95 active:translate-y-1">
            Message
          </button>
        </div>
      </div>
      <Footer/>
    </section>
  );
};

export default Contacts;
